






















































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Applicant } from "@/modules/applicants/types";
import { FetchPayload } from "@/modules/externals/types/index";
import DriversLicense from "@/modules/applicants/components/DriversLicense.vue";
import NationalId from "@/modules/applicants/components/NationalId.vue";
import Passport from "@/modules/applicants/components/Passport.vue";
import FallbackSelfies from "@/modules/applicants/components/FallbackSelfies.vue";
import SkeletonLoader from "@/modules/externals/components/SkeletonLoader.vue";
import ApplicantWarningTable from "./ApplicantWarningTable.vue";
import { User } from "@/modules/auth/types";

const Applicants = namespace("applicant");
const Auth = namespace("auth");

@Component({
  components: {
    "drivers-license": DriversLicense,
    "fallback-selfies": FallbackSelfies,
    "national-id": NationalId,
    passport: Passport,
    "skeleton-loader": SkeletonLoader,
    "all-applicant-warning-table": ApplicantWarningTable,
  },
})
export default class Summary extends Vue {
  showWarnings = false;

  @Auth.Getter("getUser") user!: User;
  @Applicants.Action("acceptApplicant") acceptApplicant!: (
    applicantId: string
  ) => Promise<{}>;
  @Applicants.Action("rejectApplicant") rejectApplicant!: (
    applicantId: string
  ) => Promise<{}>;

  @Applicants.Action("deleteApplicant") deleteApplicant!: (
    applicantId: string
  ) => Promise<{}>;

  @Applicants.Action("resetApplicant") resetApplicant!: (
    applicantId: string
  ) => Promise<{}>;

  @Applicants.Action("fetchApplicants") fetchApplicants!: (
    payload: FetchPayload
  ) => Promise<{}>;
  @Applicants.Action("fetchCurrentApplicant") fetchCurrentApplicant!: (
    applicantId: string
  ) => Promise<{}>;
  @Applicants.Getter("currentApplicant") applicant: Applicant;
  @Applicants.Getter("isLoadingCurrentApplicant")
  isLoadingCurrentApplicant: boolean;

  isRejectionLoading = false;
  isConfirmationLoading = false;
  isDeletionLoading = false;
  errMessage = "";

  mounted() {
    // Add event listener to play the video when metadata is loaded
    const videoElement = this.$refs.video as HTMLVideoElement;
    videoElement.addEventListener("click", () => {
      if (videoElement.paused) {
        videoElement.play();
      } else {
        videoElement.pause();
      }
    });
  }

  toggleWarnings(e) {
    e.preventDefault();
    this.showWarnings = !this.showWarnings;
  }

  playVideo() {
    const videoElement = this.$refs.video as HTMLVideoElement;

    if (videoElement.paused) {
      videoElement.play();
    } else {
      videoElement.pause();
    }
  }

  isSuperAdmin() {
    return this.user.role === 3;
  }

  get jsonRawData() {
    const jsonString = this.applicant?.idDocumentData?.rawData || "";
    const modifiedJsonString = jsonString.replace(
      /([^,])(\{"ApplicantId")/g,
      "$1,$2"
    );

    return JSON.stringify(modifiedJsonString, null, 2);
  }

  get jsonWarnings() {
    const jsonString = this.applicant?.idDocumentData?.rawData || "";

    // Attempt to clean up the JSON string
    let cleanedJsonString = jsonString;

    // Remove trailing commas
    cleanedJsonString = cleanedJsonString.replace(/,\s*(}|\])/g, "$1");

    // Fix broken JSON structure
    cleanedJsonString = cleanedJsonString.replace(/,\s*(}|\])/g, "$1"); // Remove trailing commas

    // Optionally, handle specific known issues
    // Example: Replace or remove specific problematic characters
    // cleanedJsonString = cleanedJsonString.replace(/someProblematicCharacter/g, '');

    // Log cleaned JSON for debugging purposes

    try {
      // Attempt to parse the cleaned JSON string
      const jsonWarnings = JSON.parse(cleanedJsonString);
      return jsonWarnings?.warning || [];
    } catch (ex) {
      // Log the error and return an empty array on parse failure

      return [];
    }
  }

  goBack() {
    this.$router.push({ name: "dashboard" });
  }

  confirmApproveApplicant() {
    const { id } = this.applicant;
    this.isConfirmationLoading = true;
    if (id) {
      this.acceptApplicant(id)
        .then(async () => {
          this.isConfirmationLoading = false;
          await this.fetchCurrentApplicant(id);
          this.$notify({
            group: "success",
            title: "Important message",
            text: "Applicant approved",
          });
        })
        .catch((err) => {
          this.isConfirmationLoading = false;
          this.errMessage = err.message;
        });
    }
  }
  confirmRejectApplicant() {
    const { id } = this.applicant;
    this.isRejectionLoading = true;

    if (id) {
      this.rejectApplicant(id)
        .then(async () => {
          this.isRejectionLoading = false;
          await this.fetchCurrentApplicant(id);
          this.$notify({
            group: "success",
            title: "Important message",
            text: "Applicant rejected",
          });
        })
        .catch((err) => {
          this.isConfirmationLoading = false;
          this.errMessage = err.message;
          this.$notify({
            group: "error",
            title: "Error",
            text: "An error occurred",
          });
        });
    }
  }

  confirmDelete() {
    const confirmed = window.confirm(
      "Are you sure you want to delete this record?"
    );
    if (confirmed) {
      this.deleteRecord();
    }
  }

  confirmReset() {
    const confirmed = window.confirm(
      "Are you sure you want to reset this record?"
    );
    if (confirmed) {
      this.resetRecord();
    }
  }

  deleteRecord() {
    const { id } = this.applicant;
    if (id) {
      this.isDeletionLoading = true;
      this.deleteApplicant(id)
        .then(async () => {
          this.isDeletionLoading = false;
          window.alert("Record was successfully deleted.");
          this.goBack();
          window.location.href = "/home/";
        })
        .catch((err) => {
          this.isDeletionLoading = false;
          this.errMessage = err.message;
          this.$notify({
            group: "error",
            title: "Error",
            text: "An error occurred",
          });
        });
    }
  }

  resetRecord() {
    const { id } = this.applicant;
    if (id) {
      this.isDeletionLoading = true;
      this.resetApplicant(id)
        .then(async () => {
          this.isDeletionLoading = false;
          window.alert("Record was successfully reset.");
          this.goBack();
          window.location.href = "/home/";
        })
        .catch((err) => {
          this.isDeletionLoading = false;
          this.errMessage = err.message;
          this.$notify({
            group: "error",
            title: "Error",
            text: "An error occurred",
          });
        });
    }
  }
}
